import { VoiceTypeEnum } from "../types/voices";

export const voiceTypes = [
  VoiceTypeEnum.Azure,
  VoiceTypeEnum.ChatGPT,
  VoiceTypeEnum.ElevenLabs
];